import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Garde une page montée après la première visite.
 * Sans cela, chaque onglet démonte le composant, remet loading=true et
 * réaffiche un écran blanc le temps d'un aller-retour API — même sans données.
 */
export default function PersistentRoute({ path, children }) {
  const { pathname } = useLocation()
  const active = pathname === path
  const [visited, setVisited] = useState(active)

  useEffect(() => {
    if (active) setVisited(true)
  }, [active])

  if (!visited && !active) return null

  const node = typeof children === 'function' ? children(active) : children

  // Ne pas utiliser display:contents : en quittant la page (ex. Paramètres),
  // certains moteurs laissent le contenu « remonté » visible par-dessus la suivante.
  return (
    <div
      style={{ display: active ? 'block' : 'none' }}
      aria-hidden={!active}
      hidden={!active}
    >
      {node}
    </div>
  )
}
